<script setup>

import { defineProps, defineEmits, ref, computed, watch} from "vue";
import ItemLinha from "./ItemLinha.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "revisandoPedido",
    "pedidoDeCompra",
    "somaItensValorDisponivelFormatado",
    "somaValorTotalFormatado",
    "somaValorSobressalenteFormatado",
    "somaCustoAdicionalFormatado",
    "itensUnidades",
    "cotacoesDePedidoDeCompra",
    "controlesDesativados",
]);

const emits = defineEmits([
    "update:itens",
    "update:item",
    "update:adicionaItem",
    "update:cotacaoDePedidoDeCompraItem"
]);

//==================================================================//
//========================== Altera Itens ==========================//
//==================================================================//

const alteraItens = (update) =>{

    emits('update:itens', update);

};

//==================================================================//
//======= Altera Cotação de Pedido de Compra Item ==================//
//==================================================================//

const alteraCotacaoDePedidoDeCompraItem = (update) =>{

    emits('update:cotacaoDePedidoDeCompraItem', update);

};

//==================================================================//
//========================== Altera Itens ==========================//
//==================================================================//

const alteraItem = (update) =>{

    emits('update:item', update);

};

//==================================================================//
//========================= Adiciona Item ==========================//
//==================================================================//

const adicionaItem = (update) =>{

    emits('update:adicionaItem', update);

};

//==================================================================//
//=========================== Remove Item ==========================//
//==================================================================//

const removeItem = (update = {}) =>{

    emits('update:removeItem', update);

};

//==================================================================//
//============ Cotação de Pedido de Compra Selecionada =============//
//==================================================================//

const cotacaoDePedidoDeCompraSelecionada = ref([]);

//==================================================================//
//========== Cotação de Pedido de Compra Item Selecionado ==========//
//==================================================================//

const cotacaoDePedidoDeCompraItemSelecionado = ref();

//==================================================================//
//========================== Busca Jobs ============================//
//==================================================================//

const buscaJobs = computed(()=>{
    return props?.pedidoDeCompra?.itens?.map(({jobCodigo})=>jobCodigo);
});
let buscaJobSelecionado = ref("");

//==================================================================//
//==================== Busca Ordens De Serviço =====================//
//==================================================================//

const buscaOrdensDeServico = computed(()=>{
    return props?.pedidoDeCompra?.itens?.map(({osCodigo})=>osCodigo);
});
let buscaOrdemDeServicoSelecionada = ref("");

//==================================================================//
//===================== Busca Palavras Chave =======================//
//==================================================================//

let buscaPalavrasChave = ref(["Teste1","Teste2"]);
let buscaPalavraChaveSelecionada = ref("");

//==================================================================//
//========================= Filtro de Job ==========================//
//==================================================================//

const filterJob = (jobCodigo) =>{

    if (!buscaJobSelecionado.value) {
        return true;
    }

    return jobCodigo.toLowerCase().includes(buscaJobSelecionado.value.toLowerCase());

}

//==================================================================//
//========================= Filtros de OS ==========================//
//==================================================================//

const filterOS = (osCodigo) =>{

    if (!buscaOrdemDeServicoSelecionada.value) {
        return true;
    }

    return osCodigo.toLowerCase().includes(buscaOrdemDeServicoSelecionada.value.toLowerCase());

}

//==================================================================//
//===================== Cotacoes Itens Header ======================//
//==================================================================//

let pedidoDeCompraItensHeaders = [
    { text: '',                             value: 'aberto',                         sortable:false},
    { text: 'Status',                       value: 'status',                         sortable:false},
    { text: 'Remover',                      value: 'remover',                        sortable:false},
    { text: 'Job',                          value: 'jobCodigo',                      class:"c-table__header",    cellClass:'c-table__item', filter: filterJob},
    { text: 'OS',                           value: 'osCodigo',                       class:"c-table__header",    cellClass:'c-table__item', filter: filterOS},
    { text: 'Sequência',                    value: 'osItemSequencia',                class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Código do Item',               value: 'osItemItemCodigo',               class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Descrição',                    value: 'osItemDescricao',                class:"c-table__header",    cellClass:'c-table__item', width:"550"},
    { text: 'Data de Solicitação',          value: 'osItemDataSolicitacao',          class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Data de Necessidade',          value: 'osItemDataNecessidade',          class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Data de Liberacao Compras',    value: 'osItemDataLiberacaoCompras',     class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Data de Entrega',              value: 'osItemDataEntrega',              class:"c-table__header",    cellClass:'c-table__item'},
    { text: 'Quantidade',                   value: 'osItemQuantidadeCompra',         class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Unidade',                      value: 'osItemUnidadeCompra.sigla',      class:"c-table__header",    cellClass:'c-table__item', filterable: false},
    { text: 'Valor Disponivel',             value: 'osItemValorDisponivel',          class:"c-table__header",    cellClass:'c-table__item', filterable: false,  width:"150", },
    { text: 'Valor Total',                  value: 'osItemPrecoTotalComImpostos',    class:"c-table__header",    cellClass:'c-table__item', filterable: false,  width:"150", },
    { text: 'Status (Item)',                value: 'osItemStatus',                   class:"c-table__header",    cellClass:'c-table__item', filterable: false},
]

//==================================================================//
//========= Ao Selelecionar Cotacoes De Pedido de Compra ===========//
//==================================================================//

const aoSelecionarCotacoesDePedidoDeCompra = (cotacaoDePedidoDeCompra) => {

    cotacaoDePedidoDeCompraSelecionada.value = cotacaoDePedidoDeCompra;

};

//==================================================================//
//====== Ao Selelecionar Cotacoes De Pedido de Compra Item =========//
//==================================================================//

const aoSelecionarCotacoesDePedidoDeCompraItem = (cotacaoDePedidoDeCompraItem) => {

    cotacaoDePedidoDeCompraItemSelecionado.value = cotacaoDePedidoDeCompraItem;

};

//==================================================================//
//====================== Ao Adicionar Item =========================//
//==================================================================//

const aoAdicinarItem = () =>{

    let cotacaoDePedidoDeCompraItem = cotacaoDePedidoDeCompraItemSelecionado.value;

    if(!cotacaoDePedidoDeCompraItem){
        return;
    }

    alteraCotacaoDePedidoDeCompraItem({
        cotacaoItem: cotacaoDePedidoDeCompraItem,
        cotacaoItemPatch:{
            adicionado: true
        }
    });

};

//==================================================================//
//============================= Reset ==============================//
//==================================================================//

const reset = () =>{

    buscaJobSelecionado.value = "";
    buscaOrdemDeServicoSelecionada.value = "";
    buscaPalavraChaveSelecionada.value = "";

}

//==================================================================//
//===================== Watch => Revisando Pedido ==================//
//==================================================================//

watch(()=> props.revisandoPedido, async () => {

    if(props.revisandoPedido == false){
        reset()
    }

});

//==================================================================//
//======= Watch => Cotacao de Pedido de Compra Item Selecionado ====//
//==================================================================//

watch(()=> cotacaoDePedidoDeCompraItemSelecionado?.value?.adicionado, (itemAdicionado) => {

    if(!itemAdicionado){
        return;
    }

    adicionaItem(cotacaoDePedidoDeCompraItemSelecionado.value);

    cotacaoDePedidoDeCompraSelecionada.value = null;
    cotacaoDePedidoDeCompraItemSelecionado.value = null;

},{ deep: true});


</script>

<template>

    <v-card>

        <v-card-title
            class="c-itens"
        >

            <h3
                class="c-itens__titulo"
            >
                Itens do Pedido
            </h3>

            <div
                class="c-itens__buscas"
            >

                <v-select
                    label="Job"
                    class="c-busca__job"
                    v-model="buscaJobSelecionado"
                    :items="buscaJobs"
                    :item-props="true"
                    item-text="codigo"
                    hide-details
                    outlined
                    return-object
                    clearable
                    :disabled="props.controlesDesativados"
                ></v-select>

                <v-select
                    label="OS"
                    class="c-busca__os"
                    v-model="buscaOrdemDeServicoSelecionada"
                    :items="buscaOrdensDeServico"
                    :item-props="true"
                    item-text="codigo"
                    hide-details
                    outlined
                    return-object
                    clearable
                    :disabled="props.controlesDesativados"
                ></v-select>

                <v-select
                    label="Palavras Chaves"
                    class="c-busca__palavraChave"
                    v-model="buscaPalavraChaveSelecionada"
                    :items="buscaPalavrasChave"
                    :item-props="true"
                    item-text="codigo"
                    hide-details
                    outlined
                    return-object
                    clearable
                    disabled
                ></v-select>

            </div>

            <div
                class="c-itens__medidores"
            >

                <div
                    class="c-medidor"
                >

                    <v-chip
                        color="green"
                        dark
                        label
                    >

                        Valor Disponivel:
                        R$ {{props?.somaItensValorDisponivelFormatado}}

                    </v-chip>

                    <v-chip
                        color="green"
                        dark
                        label
                    >

                        Valor Total:
                        R$ {{props?.somaValorTotalFormatado}}

                    </v-chip>

                </div>

                <div
                    class="c-medidor"
                >

                    <v-chip
                        color="green"
                        dark
                        label
                    >

                        Valor Sobressalente:
                        R$ {{props?.somaValorSobressalenteFormatado}}

                    </v-chip>

                    <v-chip
                        color="green"
                        dark
                        label
                    >

                        Custo Adicional:
                        R$ {{props?.somaCustoAdicionalFormatado}}

                    </v-chip>

                </div>

            </div>

            <div
                class="c-adicionar-item"
            >

                <!-- :rules="fornecedorRegras" -->
                <!-- :disabled="props.controlesDesativados" -->
                <v-autocomplete
                    label="Cotação"
                    class="c-adicionar-item__campo"
                    :value="cotacaoDePedidoDeCompraSelecionada"
                    :items="props?.cotacoesDePedidoDeCompra"
                    :item-props="true"
                    :item-text="cotacaoDePedidoDeCompra => `N° ${cotacaoDePedidoDeCompra.codigo}`"
                    outlined
                    return-object
                    @input="aoSelecionarCotacoesDePedidoDeCompra"
                >

                    <template v-slot:item="{ item }">
                        N° {{item.codigo}}
                    </template>

                </v-autocomplete>

                <v-autocomplete
                    label="Item da Cotação"
                    class="c-adicionar-item__campo"
                    :value="cotacaoDePedidoDeCompraItemSelecionado"
                    :items="cotacaoDePedidoDeCompraSelecionada?.itens"
                    :item-props="true"
                    :item-text="cotacaoDePedidoDeCompraItem => `OS-${cotacaoDePedidoDeCompraItem.osCodigo}-${cotacaoDePedidoDeCompraItem.osItemSequencia} - ${cotacaoDePedidoDeCompraItem.osItemDescricao}`"
                    outlined
                    return-object
                    @input="aoSelecionarCotacoesDePedidoDeCompraItem"
                >

                    <template v-slot:item="{ item }">
                        OS-{{item.osCodigo}}-{{item.osItemSequencia}} - {{item.osItemDescricao}}
                    </template>

                </v-autocomplete>

                <!-- :disabled="desativaNovaParcela" -->
                <!-- @click="aoAdicinarParcela" -->
                <v-btn
                    class="c-adicionar-item__botao"
                    color="primary"
                    dark
                    @click="aoAdicinarItem"
                >
                    Adicionar Item
                </v-btn>

            </div>

        </v-card-title>

        <!-- 
            Não é possivel detectar o Scroll de uma Tabela, bug não corrigido desde o Vuetify 2.5.9
            https://github.com/vuetifyjs/vuetify/issues/14254
        -->
        <v-data-table
            class="c-itens__tabela"
            :headers="pedidoDeCompraItensHeaders"
            :items="props?.pedidoDeCompra?.itens"
            item-key="id"
            elevation="0"
            :items-per-page="-1"
        >

            <template v-slot:body="{ items }">

                <tbody>

                    <ItemLinha v-for="item in items"
                        :key="item.id"
                        :revisandoPedido="props.revisandoPedido"
                        :pedidoDeCompra="props.pedidoDeCompra"
                        :item="item"
                        :itensUnidades="props.itensUnidades"
                        :controlesDesativados="props.controlesDesativados"
                        @update:itens="alteraItens"
                        @update:item="alteraItem"
                        @update:removeItem="removeItem"
                    ></ItemLinha>

                </tbody>

            </template>
    
        </v-data-table>

    </v-card>

</template>

<style scoped>

.c-itens{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: min-content min-content min-content; 
    grid-template-areas: 
    "titulo titulo"
    "buscas medidores"
    "adicionarItens adicionarItens";
    gap: 10px;
}

.c-itens__titulo {
    grid-area: titulo;
}

.c-itens__buscas {
    grid-area: buscas;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px;
    grid-template-areas: 
        "buscaJob buscaOS buscaPalavraChave";
}

.c-busca__job{
    grid-area: buscaJob;
}

.c-busca__os{
    grid-area: buscaOS;
}

.c-busca__palavraChave{
    grid-area: buscaPalavraChave;
}

.c-itens__medidores{
    grid-area: medidores;
    display: grid;
    grid-auto-flow: row;
    grid-gap: 10px;
}

.c-medidor{
    display: flex;
    grid-gap: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.c-adicionar-item{
    grid-area: adicionarItens;
    display: flex;
    gap: 10px;
}

.c-itens__tabela{
    display: grid;
    white-space: nowrap;
}

</style>